import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const localStorageKeys = {
  GLOBAL_SUPPLIER: "global_supplier",
  PINNED_SUPPLIERS: "pinned_suppliers",
  SKIP_TRIP_DEFAULTS_PROMPT: "skip_trip_defaults_prompt",
};
